import { render, staticRenderFns } from "./PostContribution.vue?vue&type=template&id=a80d58ca&scoped=true"
import script from "./PostContribution.vue?vue&type=script&lang=js"
export * from "./PostContribution.vue?vue&type=script&lang=js"
import style0 from "./PostContribution.vue?vue&type=style&index=0&id=a80d58ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80d58ca",
  null
  
)

export default component.exports